import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { footprintLocations } from "../../data/mock";
import SectionHeading from "../ui-custom/SectionHeading";
import GlassCard from "../ui-custom/GlassCard";
import Reveal from "../ui-custom/Reveal";

const FootprintTeaserSection = () => {
  return (
    <section className="relative py-24 md:py-28 px-6 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle, rgba(255, 0, 15,0.6) 1px, transparent 1px)",
          backgroundSize: "28px 28px"
        }}
      />
      <div className="relative z-10 max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Global Footprint"
          title="Manufacturing To Markets, Worldwide"
          subtitle="Group companies across India and Türkiye, sales offices on four continents, and customers in 120+ countries."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {footprintLocations.map((loc, i) => (
            <Reveal key={loc.title} delay={i * 0.08}>
              <GlassCard className="p-6 h-full">
                <MapPin size={22} className="text-qcyan mb-4" />
                <h3 className="font-display font-semibold text-foreground text-base mb-1">{loc.title}</h3>
                <p className="text-xs text-qamber uppercase tracking-wide mb-3">{loc.type}</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{loc.detail}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/footprint" className="inline-flex items-center gap-2 text-qcyan font-semibold text-sm tracking-wide hover:gap-3 transition-all">
            View Full Global Presence <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FootprintTeaserSection;
